import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { CancelAccountService } from '@zwiloo/user/context/cancel-account.service';

@Component({
    selector: 'zwi-account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.scss'],
    standalone: false
})
export class AccountComponent {
  open = false;

  constructor(
    private cancelAccountService: CancelAccountService,
    private router: Router
  ) {}
  closeAccount() {
    this.cancelAccountService.closeAccountToken();
    this.close();
  }

  openDialog() {
    this.open = true;
  }

  close() {
    this.open = false;
  }
}
